<template>
  <component :is="dynamicIcon" />
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VDynamicIcon", {
  props: {
    path: VueTypes.string
  },
  computed: {
    dynamicIcon() {
      return () =>
        import(
          /* webpackChunkName: "icons" */
          /* webpackMode: "lazy" */
          "../assets/images/postcard-icon.svg"
        );
    }
  }
});
</script>
